module.exports = "/images/bg_2de633.png";